import React from 'react';
import { string } from 'prop-types';

// Import translation
import { useTranslation } from 'react-i18next';

// Import components
import LoginModal from './LoginModal';

// Import styles
import { ModalStyled } from 'components/views/authentication/styles';

// Import utilities
import useToggle from 'components/utilities/hooks/toggle/useToggle';
import useUserAgent from 'components/utilities/hooks/user_agent/useUserAgent';

const ProviderLoginModal = ({ providerType, sourceName = '' }) => {
	const [on, toggle] = useToggle(true);
	const { isMobile } = useUserAgent();

	const { t } = useTranslation();

	const handleCancel = () => toggle();

	return (
		<ModalStyled
			maskClosable={false}
			width="64rem"
			closable={false}
			onCancel={handleCancel}
			title={t('common_login_form_provider_modal_title')}
			visible={on}
			bodyStyle={{
				padding: isMobile ? '2rem 2rem 4rem' : '2rem 9rem 6rem 9rem'
			}}
		>
			<LoginModal
				toggle={toggle}
				providerType={providerType}
				sourceName={sourceName}
			/>
		</ModalStyled>
	);
};

ProviderLoginModal.propTypes = {
	providerType: string.isRequired,
	sourceName: string
};

export default ProviderLoginModal;
